export default __webpack_public_path__ + "static/media/maleek.b856af54.png";